import React from "react";
import { Instagram, Mail, Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function SiteFooter() {
  const currentYear = new Date().getFullYear();
  return <footer data-section-id="26181" id="connect-follow" className="bg-background text-foreground py-16 px-8 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 mb-16">
          {}
          <div className="flex flex-col gap-4">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614369/img/xo_boudoir_footer_logo_refined.png" alt="XO Boudoir Logo" className="h-20 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground leading-relaxed max-w-md font-sans text-sm tracking-wide">
              XO Boudoir offers a sophisticated and empowering boudoir photography 
              experience in Minneapolis. We specialize in high-end, editorial-style 
              portraiture that celebrates your unique strength and beauty.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6 md:pl-8">
            <h3 className="font-serif text-xl font-medium tracking-widest uppercase">
              The Experience
            </h3>
            <nav className="flex flex-col gap-3">
              {[{
              label: "Services",
              href: "#"
            }, {
              label: "Portfolio",
              href: "#"
            }, {
              label: "The Process",
              href: "#"
            }, {
              label: "FAQ",
              href: "#"
            }, {
              label: "Inquiry",
              href: "#"
            }].map((link, i) => <Link key={i} data-index={i} to={link.href} className="text-muted-foreground hover:text-primary transition-colors w-fit font-sans text-sm uppercase tracking-wider">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-serif text-xl font-medium tracking-widest uppercase">
              contact us
            </h3>
            <div className="flex flex-wrap gap-4">
              {[{
              icon: Instagram,
              label: "Instagram",
              href: "https://www.instagram.com/xo.boudoir"
            }, {
              icon: Mail,
              label: "Email",
              href: "mailto:book@xoboudoir.com"
            }].map((social, i) => <Link key={i} data-index={i} to={social.href} className="group flex h-10 w-10 items-center justify-center rounded-none border border-border bg-transparent transition-all hover:border-primary hover:bg-primary/5" aria-label={social.label}>
                  <social.icon className="h-4 w-4 text-muted-foreground transition-colors group-hover:text-primary" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="bg-border" />

        <div className="pt-8 flex flex-col items-center justify-center gap-2 text-center text-xs text-muted-foreground font-sans uppercase tracking-widest">
          <p className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1">
            <span>&copy; {currentYear} XO Boudoir. All rights reserved.</span>
            <span className="hidden sm:inline opacity-30">|</span>
            <span className="flex items-center gap-1.5">
              Crafted with{" "}
              <Heart className="h-3 w-3 text-foreground/40 fill-foreground/10 animate-pulse" />{" "}
              in Minneapolis
            </span>
          </p>
        </div>
      </div>
    </footer>;
}